import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Position } from "../../modules/createCampaign/components/coverPreviewArea/coverPreviewArea";
import { BlockType } from "../../modules/createCampaign/enums/blockType";
import {
  CoverDetailModel,
  CreateCampaignModel,
} from "../../modules/createCampaign/models/createCampaignModel";
import { CustomLinkModel } from "../../modules/createCampaign/models/customLinkModel";
import { CampaignBlockModel } from "../../modules/createCampaign/models/questionModel";
import { ThemeModel } from "../../modules/createCampaign/models/themeModel";
import { TicketDetailModel } from "../../modules/createCampaign/models/ticketDetailModel";
import { fontFamily } from "../constants/fontFamily";
import { themeColor } from "../constants/themeColors";
import { MediaType } from "../enums/mediaTypes";
import { QuestionTypes } from "../enums/questionTypes";

const colors = themeColor.map((e) => ({
  type: MediaType.COLOR,
  value: e,
}));
const font = fontFamily.map((e) => ({
  value: e,
  label: <div style={{ fontFamily: e }}>{e}</div>,
}));

const initialState = {
  campaignTitle: "Untitlled Campaign",
  campaignDescription: "Description",
  coverDetail: {
    buttonText: "Continue",
    buttonPosition: Position.BOTTOM_CENTER,
  },
  theme: {
    themeColor: colors[0],
    fontFamily: font[0].value,
    fontColor: colors[9],
    desktopBackground: colors[1],
    mobileBackground: colors[1],
  },
  campaignBlock: [
    {
      blockType: BlockType.QUESTION,
      questionBlockDetail: {
        questionTitle: "Untitled Question",
        questionType: QuestionTypes.MULTIPLE_CHOICE,
      },
    },
  ],
  TicketDetail: { layoutNumber: 0 },
} as CreateCampaignModel;

export const campaignSlice = createSlice({
  name: "createCampaign",
  initialState: initialState,

  reducers: {
    loadCreateCampaignData(state, action: PayloadAction<CreateCampaignModel>) {
      return { ...state, ...action.payload };
    },
    setCampaignId(state, action: PayloadAction<string>) {
      state.id = action.payload;
    },
    setCampaignTitle(state, action: PayloadAction<string>) {
      state.campaignTitle = action.payload;
    },
    setCampaignDescription(state, action: PayloadAction<string>) {
      state.campaignDescription = action.payload;
    },
    setCoverDetail(state, action: PayloadAction<CoverDetailModel>) {
      state.coverDetail = action.payload;
    },
    setCampaignBlock(state, action: PayloadAction<CampaignBlockModel[]>) {
      state.campaignBlock = action.payload;
    },
    setTicketDetail(state, action: PayloadAction<TicketDetailModel>) {
      state.TicketDetail = action.payload;
    },
    setTheme(state, action: PayloadAction<ThemeModel>) {
      state.theme = action.payload;
    },
    setCustomLink(state, action: PayloadAction<CustomLinkModel>) {
      state.customLink = action.payload;
    },
    clearCreateCampaignData() {
      return initialState;
    },
  },
});

export const {
  setCampaignId,
  loadCreateCampaignData,
  setCampaignBlock,
  setCampaignDescription,
  setCampaignTitle,
  setCoverDetail,
  setCustomLink,
  setTheme,
  setTicketDetail,
  clearCreateCampaignData,
} = campaignSlice.actions;

export default campaignSlice.reducer;
